import { render, staticRenderFns } from "./DepartmentIcon.vue?vue&type=template&id=a6310572&scoped=true"
import script from "./DepartmentIcon.vue?vue&type=script&lang=js"
export * from "./DepartmentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6310572",
  null
  
)

export default component.exports